import React from "react";
import MobileMenu from "./MobileMenu";
import ProfileMenu from "./ProfileMenu";
import { AppLogo } from './AppLogo';
import { HamburgerButton } from './HamburgerButton';
import { AppSelectorButton } from './AppSelectorButton';
import AppSettings from '../../AppSettings/Views/AppSettings';
import { MySettings } from '../../MySettings/Views/MySettings';
import HyperFocus from '../../HyperFocus/Views/HyperFocus';
import { UserManagement } from "../../UserManagement/Views/UserManagement";
import { testIsSupportedWidth } from '../../ContentNotSupported/Views/ContentNotSupported';
import { MENU_ITEM, useNavBar } from "../Hooks/useNavBar";

/**
 * App's Main Navigation Bar.
 * @returns Navigation Bar Component
 */
const NavBar = () => {

  const {
    isMobile,
    mobileMenuShow,
    handleLogout,
    handleMobileMenuShow,
    activeMenu,
    toggleMenuItem
  } = useNavBar();

  return (
    <React.Fragment>
      <header className="l-header" data-testid="header">
        <AppLogo />
        <HamburgerButton onMenuToggle={handleMobileMenuShow} />
        {isMobile && (
          <MobileMenu
            show={mobileMenuShow}
            handleShowMySettings={() => toggleMenuItem(MENU_ITEM.MY_SETTINGS)}
            onCloseClick={handleMobileMenuShow}
            handleLogout={handleLogout}
          />
        )}
        <div className="l-header__right">
          <nav className="global-utilities">
            <ProfileMenu
              handleLogout={handleLogout}
              setActiveMenu={toggleMenuItem}
            />
            <AppSelectorButton />
          </nav>
        </div>
      </header>
      <AppSettings
        show={activeMenu === MENU_ITEM.APP_SETTINGS}
        handleShowModal={() => toggleMenuItem(MENU_ITEM.APP_SETTINGS)}
      />
      <MySettings
        show={activeMenu === MENU_ITEM.MY_SETTINGS}
        handleShowModal={() => toggleMenuItem(MENU_ITEM.MY_SETTINGS)}
      />
      <HyperFocus
        enforceFocus={false}
        title="User Management"
        idBody="user-management-hyperfocus"
        handleShowModal={() => toggleMenuItem(MENU_ITEM.USER_MANAGEMENT)}
        show={activeMenu === MENU_ITEM.USER_MANAGEMENT && testIsSupportedWidth()}
      >
        <UserManagement />
      </HyperFocus>
    </React.Fragment>
  );
};

export default NavBar;
